import Item from '../../canvas-timeline/canvas_timeline_item';
import {ITEM_TYPE, drawBackground, drawRectangle} from '../../canvas-timeline/canvas_timeline_util';
import Util from '../../../../forecast-app/shared/util/util';
class PersonGroupUtilizationItem extends Item {
	constructor(data) {
		super(ITEM_TYPE.PEOPLE_SCHEDULING_COMPANY_UTILIZATION, data);
	}

	draw(canvasContext) {
		const {data, height} = this;
		const {x, y, width, minutesAllocated, minutesAvailable, isPast, isInActualMode} = data;

		drawBackground(canvasContext, x + 1, y, width - 2, height, true);
		const percentAllocated = minutesAvailable ? Math.round((minutesAllocated / minutesAvailable) * 100) : 0;
		const isOverallocated = percentAllocated > 103;
		let secondBarColor = isPast && isInActualMode ? '#c1eaff' : isOverallocated ? '#ffcaca' : '#b2efd1';

		const completionPercentage = isOverallocated ? (minutesAvailable ? (minutesAllocated - minutesAvailable) / minutesAvailable : 0) : minutesAvailable ? minutesAllocated / minutesAvailable : 0;

		// draw vertical progress bar in the new design version
		const secondBarHeight = Util.clamp(height * completionPercentage, 0, height);
		drawRectangle(canvasContext, x, y + height - secondBarHeight, width, secondBarHeight, {
			backgroundColor: secondBarColor,
		});

		canvasContext.fillStyle = '#535353';
		canvasContext.font = '700 14px ' + Util.getFontFamily();
		const text = Math.min(percentAllocated, 200) + (percentAllocated > 200 ? '+%' : '%');
		const textWidth = canvasContext.measureText(text).width;
		canvasContext.fillText(text, x + (width - textWidth) / 2, y + (height / 2 + 7));
	}
}
export default PersonGroupUtilizationItem;
